import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
// import axios from 'axios';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { checkDomain } from './Classes/checkDomain';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(public authService: AuthService, public router: Router, private http: HttpClient) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      const params = new HttpParams().set('domain', checkDomain());

      this.http.get<any>( `${environment.HTTP}${environment.API_URL}/api/domain`, { params, withCredentials: true }).subscribe({
        next: (resp) => {
          // console.log(resp);
          if (resp?.result?.verified === true) {
            const newUrl = `${environment.HTTP}${environment.CLIENT_URL}`;
            window.location.href = newUrl;
          }
        },
        error: (err) => {
          console.error(err);
        }
      });


      // axios.defaults.withCredentials = true;
      // axios
      //   .get(environment.HTTP+environment.API_URL+'/api/domain', { params: { domain: checkDomain() } })
      //   .then((resp) => {
      //     if (resp.data.result.verified === true) {
      //       // window.history.back();
      //       const newUrl = `${environment.HTTP}${environment.CLIENT_URL}`;
      //       window.location.href = newUrl;
      //     }
      //     return true;

      //   }).catch((err) => {
          
      //   });
        
      if (this.authService.isLoggedIn !== true) {
        // window.alert('Access Denied');
        this.router.navigate(['/login'], {replaceUrl : true});
      } 
    return true;
  }

  canLoad(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree{
    if (this.authService.isLoggedIn !== true) {
      // window.alert('Access Denied');
      this.router.navigate(['/login'], {replaceUrl : true});
    } 
    return true;
  }
}
